var render, staticRenderFns
import script from "./popupIndex.vue?vue&type=script&lang=js"
export * from "./popupIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aabe962",
  null
  
)

export default component.exports